import {SET_COMPANY} from './types';

export default function actionSetCompany(payload) {
    return {
        type: SET_COMPANY, payload: payload
    };
}



// WEBPACK FOOTER //
// ./redux/actions/company.js